import { render } from "./DashboardCom.vue?vue&type=template&id=6fecc43a&scoped=true"
import script from "./DashboardCom.vue?vue&type=script&lang=js"
export * from "./DashboardCom.vue?vue&type=script&lang=js"

import "./DashboardCom.vue?vue&type=style&index=0&id=6fecc43a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fecc43a"]])

export default __exports__